import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../lib/auth';
import { AuthShell, AuthBanner, Field } from '../components/AuthShell';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setBusy(true);
    try {
      const { message } = await forgotPassword(email);
      setMessage(message);
    } catch {
      // The endpoint never reveals whether the email exists; show the same
      // reassuring message even on transient errors.
      setMessage('If an account exists for that email, a reset link has been sent.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Reset password"
      subtitle="Enter your email and we'll send you a link to reset your password."
      footer={
        <span className="muted">
          <Link to="/login">Back to sign in</Link>
        </span>
      }
    >
      {message ? (
        <AuthBanner kind="success">{message}</AuthBanner>
      ) : (
        <form onSubmit={submit}>
          <Field label="Email" type="email" value={email} onChange={setEmail} autoComplete="email" required autoFocus />
          <button type="submit" className="btn btn--accent" disabled={busy} style={{ width: '100%', height: 38 }}>
            {busy ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
